import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { getFrontendUpdateState, subscribeToFrontendUpdates, reloadFrontendForUpdate } from '../../utils/frontendUpdates';

export default function FrontendUpdateModal() {
  const [update, setUpdate] = useState(getFrontendUpdateState);
  const [postponed, setPostponed] = useState(false);
  useEffect(() => subscribeToFrontendUpdates(setUpdate), []);
  const versionId = update.version && update.version.id;
  useEffect(() => setPostponed(false), [versionId]);
  if (!update.version) return null;
  const blockedText = update.reason === 'edits'
    ? 'Finish your edits and leave this screen before updating.'
    : update.reason === 'request' ? 'Please wait for the current operation to finish.' : null;
  return <>
    {(postponed || !update.canPrompt) && (
      <button type="button" className="btn frontend-update-notice" onClick={() => setPostponed(false)}>
        Update available
      </button>
    )}
    <Modal show={!postponed && update.canPrompt} onHide={() => setPostponed(true)} animation={false}
      className="frontend-update-modal" dialogClassName="frontend-update-dialog" aria-labelledby="frontend-update-title">
      <Modal.Header>
        <Modal.Title id="frontend-update-title">A new version is ready</Modal.Title>
        <button type="button" className="close" aria-label="Close update notice" onClick={() => setPostponed(true)}>
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>Update when you have finished your work. You can keep using the current version.</p>
        {blockedText && <p className="mb-0" role="status">{blockedText}</p>}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={() => setPostponed(true)}>Later</button>
        <button type="button" className="btn btn-primary" disabled={!update.canReload} onClick={reloadFrontendForUpdate}>
          {update.reloading ? 'Updating...' : 'Update now'}
        </button>
      </Modal.Footer>
    </Modal>
  </>;
}
